/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { editRoute, newRoute } from '../../shared/services/data.service';
import { SeguroFormComponent } from "./seguro-form/seguro-form.component";
import { SeguroListComponent } from "./seguro-list/seguro-list.component";
import {seguradorasRoute} from "../seguradoras/shared/data.service";
import {seguradorasRoutes} from "../seguradoras/seguradoras-routing.module";
import {AuthGuardService} from "../../shared/services/auth-guard.service";
import {SeguradorasComponent} from "../seguradoras/seguradoras.component";

@NgModule({
  imports: [
    RouterModule.forChild([])
  ],
  exports: [
    RouterModule
  ]
})
export class SegurosRoutingModule {}

export const segurosRoutes: any[] = [
  {
    path: '',
    component: SeguroListComponent
  },{
    path: editRoute + '/:id',
    component: SeguroFormComponent
  },{
    path: newRoute,
    component: SeguroFormComponent
  },{
    path: seguradorasRoute,
    component: SeguradorasComponent,
    canActivate: [AuthGuardService],
    children: seguradorasRoutes
  }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/seguros/seguros-routing.module.ts
 **/